@if (!editing && !error) {
  <h1 (click)="allowEdit ? onEdit() : null" mat-dialog-title class="view-mode" [ngStyle]="viewOpacity ? { opacity: viewOpacity } : {}">
    @if (viewHeader) {
      <div class="white-60">
        {{ viewHeader }}
      </div>
    }
    <div class="truncate-1-line" [matTooltip]="formControl.value ?? ''" matTooltipShowDelay="500">{{ formControl.value }}</div>
    @if (showEditIcon) {
      <mat-icon [matTooltip]="editIconTooltip" matTooltipShowDelay="500" fontIcon="edit"></mat-icon>
    }
  </h1>
} @else {
  <div class="input-wrapper">
    <h1 mat-dialog-title>
      @if (editHeader) {
        <div class="white-60">
          {{ editHeader }}
        </div>
      }
      <input
        (blur)="setEditing(false)"
        (keydown.enter)="setEditing(false)"
        (keydown.tab)="setEditing(false)"
        type="text"
        [formControl]="formControl"
        [placeholder]="placeholder ?? ''"
        #editInput
        />
        <i class="return-icon" (click)="setEditing(false)" title="Hit 'Enter' to complete"></i>
      </h1>
      @if (error) {
        <p><mat-icon fontIcon="error_outline"></mat-icon>{{error}}</p>
      }
    </div>
  }
